import React from "react";
import ReactDOM from "react-dom";
import App from "./src/components/App/App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import common_sp from "./translations/sp/common.json";
import common_en from "./translations/en/common.json";

import { initializeApp } from "firebase/app";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

const firebaseConfig = {
  apiKey: "AIzaSyAaMtdVaJW4kpLhAqiJwn3XtyW2PORQqdA",
  authDomain: "paula-86679.firebaseapp.com",
  projectId: "paula-86679",
  storageBucket: "paula-86679.appspot.com",
  messagingSenderId: "698785557250",
  appId: "1:698785557250:web:995043a690e1f61803f01b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

(async () => {
  await i18next.init({
    interpolation: { escapeValue: false },
    lng: 'en',
    resources: {
      en: {
        common: common_en
      },
      sp: {
        common: common_sp
      },
    },
  });
})();

const kursorx = new kursor({
  type: 4,
  color: "#F7452D",
  removeDefaultCursor: true,
});

const root = document.getElementById("root");

ReactDOM.render(

  <BrowserRouter>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </BrowserRouter>,
  root
);
